import { Translation } from 'primeng/api';

/**
 * Traducción al español de los textos que PrimeNG resuelve por configuración global
 * (nombres de meses y días del DatePicker, mensajes vacíos de Select, etc.).
 * Sin esto el calendario renderiza en inglés, que era el default del paquete.
 *
 * `firstDayOfWeek: 1` (lunes) y `dateFormat: 'dd/mm/yy'` replican el comportamiento
 * que traía el MatDatepicker con MAT_DATE_LOCALE = 'es-AR'.
 */
export const primeNgTranslationEs: Translation = {
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  monthNames: [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
  ],
  monthNamesShort: [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
    'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
  ],
  dateFormat: 'dd/mm/yy',
  firstDayOfWeek: 1,
  today: 'Hoy',
  clear: 'Limpiar',
  weekHeader: 'Sem',
  chooseDate: 'Elegir fecha',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevYear: 'Año anterior',
  nextYear: 'Año siguiente',
  prevDecade: 'Década anterior',
  nextDecade: 'Década siguiente',
  emptyMessage: 'Sin resultados',
  emptyFilterMessage: 'Sin resultados',
};
